import React from 'react';
import { useNavigate } from 'react-router-dom';
import './UpgradePrompt.css';

const UpgradePrompt = ({ type = 'click', onClose }) => {
  const navigate = useNavigate();
  const isClick = type === 'click';

  return (
    <div className="upgrade-prompt-modal">
      <div className="upgrade-prompt-content">
        <button className="upgrade-prompt-close" onClick={onClose}>&times;</button>
        <h2 style={{ color: '#007bff', marginTop: 0 }}>
          {isClick ? 'You’ve Hit Your Click Limit!' : 'You’ve Hit Your Conversion Limit!'}
        </h2>
        <p style={{ fontSize: '1.1em', margin: '16px 0' }}>
          {isClick
            ? 'You’ve reached the maximum number of tracked clicks allowed on the Freemium plan.'
            : 'You’ve reached the maximum number of tracked conversions allowed on the Freemium plan.'}
        </p>
        <ul className="upgrade-benefits">
          <li>🚀 <strong>Unlimited</strong> tracking for clicks and conversions</li>
          <li>📊 Advanced analytics & reporting</li>
          <li>⏱️ Real-time updates and faster data</li>
          <li>💼 Priority support</li>
          <li>💾 Export your data anytime</li>
        </ul>
        <button
          className="upgrade-prompt-btn"
          onClick={() => navigate('/upgrade')}
        >
          Upgrade to Pro for $9/mo
        </button>
        <p style={{ fontSize: '0.9em', color: '#888', marginTop: '12px' }}>
          Or save with annual billing: <strong>$90/year</strong> (2 months free)
        </p>
        <p style={{ fontSize: '0.9em', color: '#888', marginTop: '4px' }}>
          Want to keep growing? Upgrade to Pro and never worry about limits again!
        </p>
      </div>
    </div>
  );
};

export default UpgradePrompt;
